// extracted by mini-css-extract-plugin
export default {"header":"Header_header__9nbk6","header__logo":"Header_header__logo__W8rXu","header__title":"Header_header__title__646vG","header__button":"Header_header__button__KZn66"};